import React, {DetailedHTMLProps, DOMAttributes, HTMLAttributes} from "react";
import {FormItem, IFormElement} from "../model/FormModel";

interface IProps extends IFormElement
{
    formItem: FormItem;
    altFormItems?: FormItem[];
    errorText?: string | null;
    elementProps?: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
}

const ErrorWrapperFE = (props: IProps) =>
{
    let {
        formItem,
        altFormItems,
        errorText,
        elementProps,
        children,
    } = props;

    altFormItems = altFormItems ?? [];

    if(!errorText){
        errorText = formItem.errorText;
    }

    if(!errorText){
        for(let altFormItem of altFormItems){
            if(altFormItem.errorText){
                errorText = altFormItem.errorText;
                break;
            }
        }
    }


    return <div
        {...elementProps}
        data-error-for-form-item-id={formItem.itemID}
        className={(elementProps?.className ?? "") + " error-wrapper" + (errorText? " has-error ion-invalid" : "")}
    >
        {altFormItems.map((altFormItemID) =>{
            return <span key={altFormItemID.itemID} data-error-for-alt-form-item-id={altFormItemID.itemID}></span>
        })}
        {children ?? ""}
        <div className="error-text">
            {errorText}
        </div>
    </div>;
}

export default ErrorWrapperFE;